import api from './api';
import authHeader from './auth-header';

class AdminService {
    getAllUsers() {
        return api.get('/admin/users', { headers: authHeader() });
    }

    deleteUser(id) {
        return api.delete(`/admin/users/${id}`, { headers: authHeader() });
    }

    updateUser(id, data) {
        return api.put(`/admin/users/${id}`, data, { headers: authHeader() });
    }
}

const adminService = new AdminService();
export default adminService; 